<div
  id="{{ 'n' + notification.id }}"
  class="notifications-item p-4 mb-4"
  (click)="markNotificationAsRead($event, notification)"
>
  <div class="d-flex flex-column-reverse flex-lg-row justify-content-lg-between align-items-lg-end mb-5">
    <h2 class="headline-20 mb-0">
      <span *ngIf="!notification.isRead">{{ 'notification.unreadCapital' | translate }}:</span>
      {{ notification.messageSubject }}
    </h2>
    <div class="d-flex align-items-center justify-content-between justify-content-lg-center">
      <span class="notification-date">
        {{ 'notification.notificationTime' | translate: { dateTime: notification.sendDate | baseFormatDate: true } }}
      </span>
      <span
        *ngIf="!notification.isRead"
        class="notifications-dot ms-2"
      ></span>
    </div>
  </div>
  <div
    class="notification-body"
    [innerHTML]="notification.messageBody"
  ></div>
</div>
